export default __webpack_public_path__ + "static/media/page404.47b5dea7.png";